export default class InstalledTariffOption {
  constructor(data) {
    this._data = data;
  }

  /**
   * @return {{
   *   installedFunctionValue: {name: string, value: *}[]
   *   status: string,
   *   tariffOptionSpecification: {
   *     group: string,
   *     id: { id: string, namespace: string, system: string }
   *     name: string
   *   }
   *   name: string,
   * }}
   * @private
   */
  get _tariffOptionObject() {
    if (
      !Array.isArray(this._data.installedTariffOption) ||
      this._data.installedTariffOption.length !== 1
    ) {
      throw new Error('Invalid InstalledTariffOption response.');
    }

    return this._data.installedTariffOption[0];
  }

  /**
   * @return {string}
   */
  get status() {
    return this._tariffOptionObject.status;
  }

  /**
   * @return {string}
   */
  get name() {
    return this._tariffOptionObject.tariffOptionSpecification.name;
  }

  /**
   * @return {string}
   */
  get id() {
    return this._tariffOptionObject.tariffOptionSpecification.id.id;
  }

  /**
   * @return {Map<string, *>}
   */
  get properties() {
    return new Map(
      this._tariffOptionObject.installedFunctionValue?.map(item => [item.name, item.value]) ?? [],
    );
  }
}
